// Enum for transit agency feature types.
export const FeaturesType = Object.freeze({
  TRANSFERS: 'transfers'
});
